// extracted by mini-css-extract-plugin
export var articlePageContainer = "d_q";
export var articlePostContainer = "d_r";
export var articlePostEditorial = "d_s";
export var articleSourcesContainer = "d_v";
export var customArticleCard = "d_w";
export var infoContainer = "d_p";
export var pageContent = "d_t";
export var relatedArticles = "d_x";